import { getOverridePaginationStyles } from './override-pagination-style';

export const getSubaccountStyles = (_, { palette = {} }) => ({
  '@global': getOverridePaginationStyles(_, { palette }),
  option: {
    height: 36,
    paddingLeft: 8,
    paddingRight: 8,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'pointer',
    '&:hover': {
      color: palette.themePrimary,
    },
  },
  optionLink: {
    color: palette.themePrimary,
    borderTop: `1px solid ${palette.neutralLight}`,
    '&[disabled]': {
      color: '#BEBBB8',
      cursor: 'not-allowed',
    },
  },
  optionIcon: {
    marginRight: 8,
    verticalAlign: 'middle',
  },
  optionSelected: {
    backgroundColor: palette.neutralLighter,
  },
  optionText: {
    lineHeight: '36px',
  },
  uiBlockerContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },

  uiBlockerBackground: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: palette.white,
    opacity: '0.4',
    zIndex: 1,
  },

  uiBlockerContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '-webkit-transform': 'translate(-50%, -50%)',
    zIndex: 1,
  },
});
